import { getClosestLocationsBySortingAlgo } from 'utils/booking/getClosestLocationsBySortingAlgo';
import { flagshipStoreExists, orderByFlagStore } from 'utils/orderByFlagStore';
import { getUserLocation } from './getUserLocation';

const resetLocationsOrder = (allLocations, sortingAlgorithm) => {
  const [userLocationExists, userLocation] = getUserLocation();

  if (userLocationExists) {
    const closestLocations = getClosestLocationsBySortingAlgo(allLocations, userLocation, sortingAlgorithm);
    const nonClosestLocations = allLocations.filter(
      location => !closestLocations.some(closestLocation => closestLocation.id === location.id),
    );
    const locationsByDistance = closestLocations.concat(
      nonClosestLocations?.sort((a, b) => a.distanceInKm - b.distanceInKm),
    );

    if (flagshipStoreExists(locationsByDistance, sortingAlgorithm)) return orderByFlagStore(locationsByDistance);
    else return locationsByDistance;
  } else {
    const resetLocations = allLocations.map(location => {
      location.distanceInKm = undefined;
      return location;
    });
    const sortedResetLocations = resetLocations.sort((a, b) => a.heading.localeCompare(b.heading));

    if (flagshipStoreExists(sortedResetLocations, sortingAlgorithm)) return orderByFlagStore(sortedResetLocations);
    else return sortedResetLocations;
  }
};

export { resetLocationsOrder };
